module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_8003.4df804e3.png";